(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured_raquettes_slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  function preloadSlideImages(slides) {
    slides.forEach(function(slide) {
      var img = slide.querySelector('.raquettes-slider__product-img');
      if (!img) return;
      var src = img.currentSrc || img.src;
      if (!src) return;
      var preloader = new Image();
      preloader.src = src;
      var srcset = img.getAttribute('srcset');
      if (srcset) {
        preloader.srcset = srcset;
      }
    });
  }

  function initSlider(container) {
    var track = container.querySelector('.raquettes-slider__track');
    if (!track) return;

    var slides = track.querySelectorAll('.raquettes-slider__slide');
    var totalSlides = slides.length;
    if (totalSlides <= 1) return;

    var current = 0;
    var btnPrev = container.querySelector('[data-slider-prev]');
    var btnNext = container.querySelector('[data-slider-next]');
    var dots = container.querySelectorAll('[data-slider-dot]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      track.style.transition = 'none';
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, totalSlides - 1));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      updateUI();
      warmAdjacentSlides(current);
    }

    function warmAdjacentSlides(index) {
      var adjacent = [];
      if (index + 1 < totalSlides) adjacent.push(slides[index + 1]);
      if (index - 1 >= 0) adjacent.push(slides[index - 1]);
      preloadSlideImages(adjacent);
    }

    function updateUI() {
      dots.forEach(function(dot, i) {
        var isActive = i === current;
        dot.classList.toggle('raquettes-slider__dash--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      if (btnPrev) btnPrev.classList.toggle('is-disabled', current === 0);
      if (btnNext) btnNext.classList.toggle('is-disabled', current === totalSlides - 1);
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function() { goTo(current - 1); });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function() { goTo(current + 1); });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.getAttribute('data-slider-dot'), 10));
      });
    });

    var touchStartX = 0;
    var SWIPE_THRESHOLD = 50;

    track.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', function(e) {
      var delta = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(delta) > SWIPE_THRESHOLD) {
        goTo(delta > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    updateUI();
    preloadSlideImages(Array.prototype.slice.call(slides));
  }

  document.querySelectorAll('.raquettes-slider').forEach(function(container) {
    initSlider(container);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  var items = document.querySelectorAll('.site-header__nav-item--has-dropdown');
  var closeTimeouts = new Map();

  function closeAll() {
    items.forEach(function(item) {
      item.classList.remove('is-open');
      var link = item.querySelector('.site-header__nav-link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('has-mega-open');
  }

  items.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      var existing = closeTimeouts.get(item);
      if (existing) clearTimeout(existing);
      closeAll();
      item.classList.add('is-open');
      document.body.classList.add('has-mega-open');
      var link = item.querySelector('.site-header__nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    });

    item.addEventListener('mouseleave', function() {
      var t = setTimeout(function() {
        item.classList.remove('is-open');
        var link = item.querySelector('.site-header__nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
        if (!document.querySelector('.site-header__nav-item--has-dropdown.is-open')) {
          document.body.classList.remove('has-mega-open');
        }
      }, 180);
      closeTimeouts.set(item, t);
    });
  });

  document.addEventListener('click', function(e) {
    var inside = e.target.closest('.site-header__nav-item--has-dropdown');
    if (!inside) closeAll();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram_feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PLAYING_CLASS = 'is-playing';

    function initFeed(section) {
      var cards = section.querySelectorAll('.ig-feed__card--has-video');
      var activeVideo = null;

      cards.forEach(function (card) {
        var btn = card.querySelector('.ig-feed__play-btn');
        var video = card.querySelector('.ig-feed__video');
        var poster = card.querySelector('.ig-feed__poster');
        if (!btn || !video) return;

        btn.addEventListener('click', function () {
          if (card.classList.contains(PLAYING_CLASS)) return;

          if (activeVideo && activeVideo !== video) {
            var activeCard = activeVideo.closest('.ig-feed__card');
            activeVideo.pause();
            activeVideo.currentTime = 0;
            if (activeCard) {
              activeCard.classList.remove(PLAYING_CLASS);
              var activeBtn = activeCard.querySelector('.ig-feed__play-btn');
              if (activeBtn) activeBtn.setAttribute('aria-pressed', 'false');
            }
            var activePoster = activeVideo.closest('.ig-feed__card').querySelector('.ig-feed__poster');
            if (activePoster) activePoster.style.display = '';
            activeVideo.style.display = 'none';
          }

          video.style.display = '';
          if (poster) poster.style.display = 'none';
          card.classList.add(PLAYING_CLASS);
          btn.setAttribute('aria-pressed', 'true');
          activeVideo = video;

          // Click = user gesture -> autoplay avec son autorise
          video.muted = false;
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            var p = video.play();
            if (p && typeof p.catch === 'function') {
              p.catch(function () {
                // Si autoplay rejette (ex Safari strict), retry mute
                video.muted = true;
                video.play().catch(function () {});
              });
            }
          }
        });

        video.addEventListener('ended', function () {
          card.classList.remove(PLAYING_CLASS);
          btn.setAttribute('aria-pressed', 'false');
          video.style.display = 'none';
          if (poster) poster.style.display = '';
          video.muted = true;
          activeVideo = null;
        });
      });
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-section-id]');
      if (section) initFeed(section.closest('section') || section.parentElement);
    });

    document.querySelectorAll('.ig-feed[data-section-id]').forEach(initFeed);
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raquettes_comparateur"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---- Mobile : egaliser hauteurs par row entre sticky-col et colonnes produits ---- */
    function syncMobileHeights(section) {
      var mq = window.matchMedia('(max-width: 767px)');
      if (!mq.matches) return;

      var mobileLayout = section.querySelector('.rc__mobile-layout');
      if (!mobileLayout) return;

      /* 1. Egaliser le spacer header avec les headers produits */
      var headerCells = mobileLayout.querySelectorAll('.rc__product-cell--header');
      var spacer = mobileLayout.querySelector('.rc__sticky-cell--header');
      if (spacer && headerCells.length > 0) {
        spacer.style.minHeight = '';
        headerCells.forEach(function (c) { c.style.minHeight = ''; });
        var maxH = 0;
        headerCells.forEach(function (c) { maxH = Math.max(maxH, c.offsetHeight); });
        spacer.style.minHeight = maxH + 'px';
        headerCells.forEach(function (c) { c.style.minHeight = maxH + 'px'; });
      }

      /* 2. Egaliser chaque row spec entre sticky-cell et product-cell--spec */
      var stickyCells = mobileLayout.querySelectorAll('.rc__sticky-cell:not(.rc__sticky-cell--header)');
      stickyCells.forEach(function (stickyCell, idx) {
        var allSpecCells = [];
        mobileLayout.querySelectorAll('.rc__product-col').forEach(function (col) {
          var cells = col.querySelectorAll('.rc__product-cell--spec');
          if (cells[idx]) allSpecCells.push(cells[idx]);
        });
        /* Reset */
        stickyCell.style.minHeight = '';
        allSpecCells.forEach(function (c) { c.style.minHeight = ''; });
        /* Mesurer */
        var maxH = stickyCell.offsetHeight;
        allSpecCells.forEach(function (c) { maxH = Math.max(maxH, c.offsetHeight); });
        /* Appliquer */
        stickyCell.style.minHeight = maxH + 'px';
        allSpecCells.forEach(function (c) { c.style.minHeight = maxH + 'px'; });
      });
    }

    document.querySelectorAll('[data-rc-section]').forEach(function (section) {
      /* ---- Sync hauteurs au load et resize ---- */
      var sectionId = section.getAttribute('data-rc-section');
      var toast = document.querySelector('[data-rc-toast="' + sectionId + '"]');
      var toastTimer = null;
      var resizeTimer = null;

      function syncAll() {
        syncMobileHeights(section);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncAll);
      } else {
        syncAll();
      }
      // Re-sync apres chargement des images produit
      window.addEventListener('load', syncAll);
      section.querySelectorAll('.rc__product-cell--header img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', syncAll);
        img.addEventListener('error', syncAll);
      });
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncAll, 120);
      });

      /* ---- AJAX panier - pattern identique PDP ---- */
      function initAddToCart() {
        var forms = section.querySelectorAll('[data-rc-form]');
        forms.forEach(function (form) {
          if (form.dataset.rcAjaxBound === '1') return;
          form.dataset.rcAjaxBound = '1';
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            var btn = form.querySelector('.rc__product-btn');
            if (btn) {
              btn.disabled = true;
              btn.setAttribute('aria-busy', 'true');
            }
            var formData = new FormData(form);
            formData.append('sections', 'cart-drawer-items');
            formData.append('sections_url', window.location.pathname);
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData
            })
              .then(function (r) {
                return r.json().then(function (d) {
                  if (!r.ok) throw new Error(d.description || 'Ajout impossible');
                  return d;
                });
              })
              .then(function (data) {
                if (data.sections && data.sections['cart-drawer-items']) {
                  var container = document.getElementById('cart-drawer-items');
                  if (container) {
                    var tmp = document.createElement('div');
                    tmp.innerHTML = data.sections['cart-drawer-items'];
                    var wrapper = tmp.querySelector('#shopify-section-cart-drawer-items');
                    container.innerHTML = wrapper ? wrapper.innerHTML : data.sections['cart-drawer-items'];
                  }
                }
                var trigger = document.querySelector('[data-cart-drawer-trigger]');
                if (trigger) {
                  trigger.click();
                } else {
                  window.location.href = '/cart';
                }
              })
              .catch(function (err) {
                console.error('Comparateur add to cart error:', err);
                window.location.href = '/cart';
              })
              .finally(function () {
                if (btn) {
                  btn.disabled = false;
                  btn.removeAttribute('aria-busy');
                }
              });
          });
        });
      }

      initAddToCart();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
